import { isCodeCollectState, isGateState, isHoldPhase } from "../lib/digits";
import { useStore } from "../lib/store";
import { cx } from "./ui";

/**
 * Display-only expected-vs-entered strip. Never auto-Accept.
 */
export function CodeCompare() {
  const snapshot = useStore().state.snapshot;
  const { digits, expected_code, codeMatch, digitKind } = snapshot;
  const collecting = digitKind === "otp" && isCodeCollectState(snapshot.state, snapshot.detail);
  const expected = collecting ? expected_code?.trim() || "" : "";
  if (digitKind === "gate" || isGateState(snapshot.state, snapshot.detail)) {
    return (
      <div className="flex min-h-[110px] flex-1 flex-col justify-center px-6">
        <div className="font-mono text-[11px] tracking-[0.18em] text-mute">ident</div>
        <div className="mt-2 font-mono text-xl text-mute">gate — not a code</div>
      </div>
    );
  }
  if (isHoldPhase(snapshot.state, snapshot.detail)) {
    return (
      <div className="flex min-h-[110px] flex-1 flex-col justify-center px-6">
        <div className="font-mono text-[11px] tracking-[0.18em] text-mute">hold</div>
        <div className="mt-2 font-mono text-xl text-mute">no digits</div>
      </div>
    );
  }
  const entered = digits ?? "";
  let kind: "unknown" | "match" | "mismatch" = "unknown";
  let text = "expected —";
  // NO only on a stored miss or a finished wrong entry. Partial digits are not a verdict.
  if (!expected) {
    kind = "unknown";
    text = "expected —";
  } else if (codeMatch === false || (entered.length >= expected.length && entered !== expected)) {
    kind = "mismatch";
    text = `expected ${expected}  NO`;
  } else if (codeMatch === true || entered === expected) {
    kind = "match";
    text = `expected ${expected}  MATCH`;
  } else {
    kind = "unknown";
    text = `expected ${expected}`;
  }
  return (
    <div className="flex min-h-[110px] flex-1 flex-col justify-center px-6">
      <div className="font-mono text-[11px] tracking-[0.18em] text-mute">known OTP</div>
      <div
        className={cx(
          "mt-2 font-mono text-xl tracking-wide",
          kind === "match" && "text-ok",
          kind === "mismatch" && "text-fail",
          kind === "unknown" && "text-mute",
        )}
      >
        {text}
      </div>
      <p className="mt-2 text-xs text-mute">Operator Accept is authoritative. Never auto-accept.</p>
    </div>
  );
}
